// Recovered compiled webpack factory 42542. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "notFound", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = "" + r(37099).HTTP_ERROR_FALLBACK_ERROR_CODE + ";404";
  function a() {
    let e = Object.defineProperty(Error(n), "__NEXT_ERROR_CODE", {
      value: "E394",
      enumerable: !1,
      configurable: !0,
    });
    throw ((e.digest = n), e);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
